<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>短信群发</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <el-tabs :value="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="所有" name=""></el-tab-pane>
        <el-tab-pane label="未发送" name="0"></el-tab-pane>
        <el-tab-pane label="已发送" name="1"></el-tab-pane>
        <el-tab-pane label="发送失败" name="2"></el-tab-pane>
      </el-tabs>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions, mapMutations } from 'vuex';
import List from './components/list';

export default {
  name: 'tasks',
  data() {
    return {};
  },
  components: {
    List
  },
  computed: {
    ...mapState('message', ['pagination', 'activeTab'])
  },
  methods: {
    ...mapActions('message', ['getMessages']),
    ...mapMutations('userBill', ['changeTab']),
    handleTabChange(tab) {
      this.changeTab(tab.name);
      this.getList({ page: 1 });
    },
    getList(data = {}) {
      this.getMessages({
        sendStatus: this.activeTab,
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
